import React, { Component } from 'react';

class Contact extends Component {
   constructor(){
      super();
      this.state = {
         showLoader : false,
         contactName : "",
         contactEmail:"",
         contactSubject:"",
         contactMessage:""

      }
      this.handleLoader = this.handleLoader.bind(this);
   }
   handleLoader(){
      this.setState({showLoader:true});
      setTimeout(() => {
      this.setState({
         showLoader : false,
         contactName : "",
         contactEmail:"",
         contactSubject:"",
         contactMessage:""
      });
      }, 2000);
      // console.log("Click me: ", this.state.contactName, this.state.contactEmail, this.state.contactSubject, this.state.contactMessage);
   }
   render() {
      
      if(this.props.data){
      var name = this.props.data.name;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">

            <div className="two columns header-col">

               <h1><span>Get In Touch.</span></h1>

            </div>

            <div className="ten columns">

                  <p className="lead">{message}</p>

            </div>

         </div>

         <div className="row">
            <div className="eight columns">

               {/* <form 
               action="" method="post" id="contactForm" name="contactForm"
               > */}
					{/* <fieldset> */}

                  <div>
						   <label htmlFor="contactName">Name <span className="required">*</span></label>
						   <input type="text" value={this.state.contactName} size="35" id="contactName" name="contactName" onChange={(e)=>{this.setState({contactName:e.target.value})}}/>
                  </div>

                  <div>
						   <label htmlFor="contactEmail">Email <span className="required">*</span></label>
						   <input type="text" value={this.state.contactEmail} size="35" id="contactEmail" name="contactEmail" onChange={(e)=>{this.setState({contactEmail:e.target.value})}}/>
                  </div>

                  <div>
						   <label htmlFor="contactSubject">Subject</label>
						   <input type="text" value={this.state.contactSubject} size="35" id="contactSubject" name="contactSubject" onChange={(e)=>{this.setState({contactSubject:e.target.value})}}/>
                  </div>

                  <div>
                     <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                     <textarea value={this.state.contactMessage} cols="50" rows="15" id="contactMessage" name="contactMessage" onChange={(e)=>{this.setState({contactMessage:e.target.value})}}></textarea>
                  </div>

                  <div style={{display:'flex', alignItems:'center'}}>
                     <button className="submit" onClick={this.handleLoader}>Submit</button>
                     <span id="image-loader">
                        <img alt="" src="images/loader.gif" />
                     </span>
                     {
                        this.state.showLoader && 
                        <span style={{marginLeft:'15px'}}>Your Message Could not send!</span>
                     }
                  </div>
					{/* </fieldset> */}
				   {/* </form> */}

           <div id="message-warning"> Error boy</div>
				   <div id="message-success">
                  <i className="fa fa-check"></i>Your message was sent, thank you!<br />
				   </div>
           </div>


            <aside className="four columns footer-widgets">
               <div className="widget widget_contact">

					   <h4>Address and Phone</h4>
					   <p className="address">
						   {name}<br />
						   {street} <br />
						   {city}, {state} {zip}<br />
						   <span>{phone}</span>
					   </p>
				   </div>

               {/* <div className="widget widget_tweets">
                  <h4 className="widget-title">Latest Tweets</h4>
                  <ul id="twitter">
                     <li>
                        <span>
                        This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
                        Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum
                        <a href="#">http://t.co/CGIrdxIlI3</a>
                        </span>
                        <b><a href="#">2 Days Ago</a></b>
                     </li>
                     <li>
                        <span>
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam,
                        eaque ipsa quae ab illo inventore veritatis et quasi
                        <a href="#">http://t.co/CGIrdxIlI3</a>
                        </span>
                        <b><a href="#">3 Days Ago</a></b>
                     </li>
                  </ul>
		         </div> */}
            </aside>
      </div>
   </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js